var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@mp/locale';
import interior from './interior.svg';
import interiorResidential from './interiorResidential.svg';
import interiorAndExterior from './interiorAndExterior.svg';
import interiorAndExteriorResidential from './interiorAndExteriorResidential.svg';
import './CaptureRequirements.scss';
export default function CaptureRequirementsDetail(_a) {
    var captureType = _a.captureType, propertyType = _a.propertyType;
    var isResidential = propertyType.toLowerCase() === 'residential';
    var imageMap = {
        SPACE_TYPE_INDOOR_ONLY: isResidential ? interiorResidential : interior,
        SPACE_TYPE_INDOOR_OUTDOOR_ONLY: isResidential ? interiorAndExteriorResidential : interiorAndExterior,
    };
    if (!captureType) {
        return null;
    }
    return (_jsxs("div", __assign({ className: "capture-services-capture-information" }, { children: [_jsxs("div", __assign({ className: "capture-services-capture-information-choice" }, { children: [_jsx("img", { src: imageMap[captureType] }), _jsxs("div", __assign({ className: "capture-services-capture-information-text" }, { children: [_jsx("h3", { children: t("CAPTURE_SERVICES.SCHEDULER.CAPTURE_QUESTIONS.".concat(captureType, ".label")) }), _jsx("p", { children: t("CAPTURE_SERVICES.SCHEDULER.CAPTURE_QUESTIONS.".concat(captureType, ".description")) })] }))] })), _jsxs("div", __assign({ className: "capture-services-capture-details-text" }, { children: [_jsx("h3", { children: t('CAPTURE_SERVICES.SCHEDULER.CAPTURE_QUESTIONS.INFORMATION.title') }), _jsx("div", __assign({ className: "capture-services-capture-details-description" }, { children: _jsx("p", { children: t("CAPTURE_SERVICES.SCHEDULER.CAPTURE_QUESTIONS.".concat(captureType, ".details")) }) }))] }))] })));
}
